import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmKbPermissionsRoute: InvariantJiraRoute = {
	name: 'products-jsm-kb-permissions',
	path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
	exact: true,
};
